import Diapers from '../sections/diapers/diapers';

export default function DiapersPage() {
  return (
    <div className="section-page">
      <Diapers />
    </div>
  );
}
